import {
  ALL_FIXED_PHASE_VALUE,
  REMEDIATION_IN_PROGRESS_PHASE_VALUE,
  LIVE_TESTS_PHASE_VALUE,
  NO_TESTS_PHASE_VALUE,
  RESULTS_READY_PHASE_VALUE,
  UNKNOWN_PHASE_VALUE,
} from "../constants/definitions";

/*********************************/
/*       SCORING FUNCTIONS       */
/*********************************/

// Get Score for Phase - as a way to sort
export function getScoreForPhase(webappphase: string): number {
  const uppercaseWebAppPhase = webappphase.toUpperCase();

  if (NO_TESTS_PHASE_VALUE.toUpperCase() === uppercaseWebAppPhase) {
    return 1;
  }
  if (LIVE_TESTS_PHASE_VALUE.toUpperCase() === uppercaseWebAppPhase) {
    return 2;
  }
  if (RESULTS_READY_PHASE_VALUE.toUpperCase() === uppercaseWebAppPhase) {
    return 3;
  }
  if (REMEDIATION_IN_PROGRESS_PHASE_VALUE.toUpperCase() === uppercaseWebAppPhase) {
    return 4;
  }
  if (ALL_FIXED_PHASE_VALUE.toUpperCase() === uppercaseWebAppPhase) {
    return 5;
  }
  if (UNKNOWN_PHASE_VALUE.toUpperCase() === uppercaseWebAppPhase) {
    return 6;
  }

  return 0;
}
